export const validateUen = uen => {
  return uen.length === 10 && /^\d+$/.test(uen);
};

export const getCurrentData = () => {
  const stringData = localStorage.getItem("data");
  let data = {};

  try {
    data = JSON.parse(stringData);
  } catch (e) {}
  return typeof data === "object" ? data : {};
};

export const setCurrentData = data => {
  if (typeof data === "object") {
    localStorage.setItem("data", JSON.stringify(data));
    return data;
  }
  if (data == null) {
    localStorage.removeItem("data");
  }
};

export const abbreviateNumber = (num, digits = 2) => {
  var units = ["k", "M", "G", "T", "P", "E"],
    decimal;

  for (var i = units.length - 1; i >= 0; i--) {
    decimal = Math.pow(1000, i + 1);

    if (num <= -decimal || num >= decimal) {
      return +(num / decimal).toFixed(digits) + " " + units[i];
    }
  }

  return num;
};

export const formatOrganizationTitle = (name, legalForm = null) => {
  const MAX_ORG_NAME_LENGTH = 40;

  let title = `${
    name.length <= MAX_ORG_NAME_LENGTH
      ? name
      : name.substring(0, MAX_ORG_NAME_LENGTH + 100) + " ..."
  }`;

  return legalForm ? `${title} (${legalForm})` : title;
};

export const formatUen = uen => {
  uen = uen
    .trim()
    .replace(/[a-zA-Z]{2,}/, "BE")
    .replace(/BE_/, "");

  return uen.replace(
    /(BE|be)? ?0?(\d{3})[. ]?(\d{3})[. ]?(\d{3})/,
    "BE 0$2.$3.$4"
  );
};

export const resolveDataState = (status, organization) => {
  let result = {};

  if (["CREATED", "FETCHED"].includes(status)) {
    result = {
      status: "PENDING",
      colorClass: "warning",
      message: "Waiting for search"
    };
  } else if ("PROCESSED" === status) {
    result = {
      status: "ACTIVATED",
      colorClass: "success",
      message: "Client's Data is found"
    };
  } else if ("FETCH_FAILED" === status) {
    result = {
      status: "DEACTIVATED",
      colorClass: "alert",
      message: "Client's Data is found"
    };
  } else if ("INFOS_NOT_COMPLETED" === status) {
    result = {
      status: "INCOMPLETED INFOS",
      colorClass: "warning",
      message: !organization.uen
        ? "Unable to search client's data, VAT number is missed"
        : "Incompleted client's infos"
    };
  } else if ("EXTERNAL" === status) {
    result = {
      status: "EXTERNAL",
      colorClass: "draft",
      message: "Organization found in Data.be"
    };
  } else if ("PORCESS_FAILED" === status) {
    result = {
      status: "ERROR",
      colorClass: "alert",
      message: "Fetch data error has occurred"
    };
  } else {
    result = {
      status: "ERROR",
      colorClass: "alert",
      message: "An error has occurred"
    };
  }

  return result;
};

export const resolveOrganizationState = (status, globalState) => {
  let result = {};

  if ("EXTERNAL" === status) {
    result = {
      status: "EXTERNAL",
      colorClass: "draft",
      message: "Organization found in Data.be"
    };
  } else {
    result = globalState;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/utils/data.js